import { render, staticRenderFns } from "./VxStatisticBadge.vue?vue&type=template&id=6e54c863&scoped=true"
import script from "./VxStatisticBadge.vue?vue&type=script&lang=js"
export * from "./VxStatisticBadge.vue?vue&type=script&lang=js"
import style0 from "./VxStatisticBadge.vue?vue&type=style&index=0&id=6e54c863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54c863",
  null
  
)

export default component.exports